import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastService } from './services/toast.service';
import { ToastComponent } from './components/toast.component';
import { DomService } from '../services/dom.service';
import { PortalInjector } from '../portal/portal-injector';
import { OverlayContainer } from '../overlay/overlay-container';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        ToastComponent,
    ],
    entryComponents: [
        ToastComponent,
    ],
    providers: [
        DomService,
        ToastService,
        OverlayContainer,
    ],
})

export class ToastModule {}
